<div class="panel-filtros">
    <section class="aplicados" *ngIf="aplicados.length > 0">
        <h4>Filtros aplicados</h4>
        <div class="etiquetas">
            <button type="button" class="etiqueta" *ngFor="let aplicado of aplicados; trackBy: claveAplicado"
                    (click)="quitar(aplicado)"
                    [attr.aria-label]="'Quitar ' + aplicado.texto">
                {{ aplicado.texto }}<span class="cruz" aria-hidden="true">×</span>
            </button>
        </div>
        <button type="button" class="borrar-todos" (click)="borrarTodos()">Borrar todos</button>
    </section>

    <section class="seccion" *ngFor="let seccion of secciones" [ngSwitch]="seccion.tipo === 'sino' ? 'casillas' : seccion.tipo">
        <h4>{{ seccion.titulo }}</h4>
        <!-- Casillas y Sí / No -->
        <div class="casillas" *ngSwitchCase="'casillas'">
            <mat-checkbox *ngFor="let opcion of visibles(seccion); trackBy: claveOpcion" color="primary"
                          [checked]="marcado(seccion, opcion.valor)"
                          (change)="alternar(seccion, opcion.valor, $event.checked)">{{ opcion.etiqueta }}
            </mat-checkbox>
            <!-- Sin cerrar el menú: el host del panel para el click en be-filtering2 -->
            <button type="button" class="ver-todos" *ngIf="enlaceVerTodos(seccion) as enlace"
                    (click)="alternarVerTodos(seccion)">{{ enlace }}</button>
        </div>

        <!-- Desde / hasta. El calendario es otro overlay, fuera del mat-menu: sus clics no lo cierran -->
        <div class="fechas" *ngSwitchCase="'fechas'">
            <mat-form-field appearance="outline" class="campo">
                <mat-label>Desde</mat-label>
                <input matInput autocomplete="off" [matDatepicker]="calendarioDesde"
                       [attr.aria-label]="seccion.titulo + ' desde'"
                       [value]="fechas[seccion.propiedad]?.desde"
                       [max]="fechas[seccion.propiedad]?.hasta"
                       (dateChange)="fechaElegida(seccion, 'desde', $event)"
                       (keydown)="teclaEnTexto($event)">
                <mat-datepicker-toggle matSuffix [for]="calendarioDesde"></mat-datepicker-toggle>
                <mat-datepicker #calendarioDesde></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="campo">
                <mat-label>Hasta</mat-label>
                <input matInput autocomplete="off" [matDatepicker]="calendarioHasta"
                       [attr.aria-label]="seccion.titulo + ' hasta'"
                       [value]="fechas[seccion.propiedad]?.hasta"
                       [min]="fechas[seccion.propiedad]?.desde"
                       (dateChange)="fechaElegida(seccion, 'hasta', $event)"
                       (keydown)="teclaEnTexto($event)">
                <mat-datepicker-toggle matSuffix [for]="calendarioHasta"></mat-datepicker-toggle>
                <mat-datepicker #calendarioHasta></mat-datepicker>
            </mat-form-field>
        </div>

        <!-- Buscador: lo elegido en etiquetas (varios = O) y un campo con sugerencias -->
        <ng-container *ngSwitchCase="'buscador'">
            <div class="etiquetas elegidos" *ngIf="elegidos(seccion).length > 0">
                <button type="button" class="etiqueta" *ngFor="let elegido of elegidos(seccion); trackBy: claveAplicado"
                        (click)="quitar(elegido)"
                        [attr.aria-label]="'Quitar ' + elegido.texto">
                    {{ etiqueta(seccion, elegido.valor) }}<span class="cruz" aria-hidden="true">×</span>
                </button>
            </div>
            <mat-form-field appearance="outline" class="campo campo-buscador">
                <input matInput type="text" autocomplete="off" placeholder="Escribe para buscar"
                       #campoBuscador #disparador="matAutocompleteTrigger"
                       [attr.aria-label]="seccion.titulo"
                       [matAutocomplete]="sugerenciasBuscador"
                       (input)="buscar(seccion, campoBuscador.value)"
                       (keydown)="teclaEnBuscador($event, disparador)">
                <mat-autocomplete #sugerenciasBuscador="matAutocomplete" autoActiveFirstOption [displayWith]="sinTexto"
                                  (optionSelected)="elegir(seccion, $event.option.value, campoBuscador)">
                    <mat-option *ngFor="let opcion of sugerencias[seccion.propiedad] || []" [value]="opcion">
                        {{ opcion.etiqueta }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>

        <!-- Texto. keydown parado (menos Escape y Tab, que cierran el menú): el mat-menu se queda Inicio/Fin y las flechas -->
        <mat-form-field appearance="outline" class="campo" *ngSwitchDefault>
            <input matInput type="text" autocomplete="off" [attr.aria-label]="seccion.titulo"
                   [value]="valores[seccion.propiedad]"
                   (input)="escrito(seccion, $any($event.target).value)"
                   (keydown)="teclaEnTexto($event)">
        </mat-form-field>
    </section>
</div>
